import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold2 } from "./SpinAndHold2";
import { SpinAndHold2Params } from "./SpinAndHold2Params";

export interface ISpinAndHoldBonusFactory2 {
	CreateSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): SpinAndHold2;
}

export class SpinAndHoldBonusFactory2 implements ISpinAndHoldBonusFactory2 {

	public CreateSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): SpinAndHold2 {
		return new SpinAndHold2(gameName, params, config);
	}
}